"use client";
import HighlightedText from "./HighlightedText";
import React from "react";

interface ComponentSectionProps {
    data: {
        id: string;
        sectionTitle: string;
        sectionDescription: string;
        subSection?: {
            label: string;
            listLabel?: {
                discription: string;
                wrapImage?: Picture
            }[];
        }[];
        arcDirection?: string;
    };

}

interface Picture {
    data: {
        id: string;
        attributes: {
            url: string;
            name: string;
            alternativeText: string;
        };
    };
}
export default function ComponentSection({ data }: ComponentSectionProps) {

    const ProcessStepWithoutImage = ({ step }: any) => {
        return step.wrapImage?.data?.attributes?.url ? <div>
            <img
                src={step.wrapImage?.data?.attributes?.url || ''}
                alt="" />
        </div> : <HighlightedText
            text={step.description}
            tag='p'
            className="text-gray-700 text-xl mb-6 lh-[30px] color-[#032D60]"
        />
    };
    return (
        <div className="flex justify-center max-sm:px-5 ">
            <div className="max-w-6xl w-full mx-4">
                <div className="lg text-left">
                    <HighlightedText
                        text={data.sectionTitle}
                        tag='div'
                        className="text-3xl font-bold text-[#0095EB] mb-6"
                    />
                    <HighlightedText
                        text={data.sectionDescription}
                        tag='p'
                        className="text-gray-700 text-xl mb-6 lh-[35px]"
                    />
                </div>
                <div className="lg text-left">
                    {data.subSection?.map((section, sectionIndex) => (
                        <div key={sectionIndex} className="mb-8 md:mb-12">
                            {/* Section Label */}
                            <h2 className="text-xl md:text-2xl font-bold text-[#0095EB] mb-6 md:mb-8">
                                {section.label}
                            </h2>

                            {/* Process Flow - Single Row Layout */}
                            <div className="relative">
                                <div className="flex items-center w-full justify-between overflow-x-auto pb-2">
                                    {section.listLabel?.map((step, stepIndex) => (
                                        <React.Fragment key={stepIndex}>
                                            <ProcessStepWithoutImage step={step} />
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}